import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  className?: string;
  href?: string;
  onClick?: () => void;
  external?: boolean;
}
export function CTAButton({
  text = 'QUIERO EL MÉTODO DE 7 DÍAS',
  className = '',
  href = '#offer',
  onClick,
  external = false
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      onClick();
    }
  };
  return <motion.a href={href} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} onClick={handleClick} whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.97
  }} className={`inline-flex items-center justify-center w-full md:w-auto px-10 py-5 text-center text-white font-bold text-sm md:text-base uppercase tracking-wide rounded-full bg-maternal-orange shadow-lg shadow-maternal-orange/30 hover:shadow-xl hover:shadow-maternal-orange/40 transition-all duration-300 ${className}`} data-id="element-254">
      {text}
      <ArrowRight className="w-5 h-5 ml-2" data-id="element-255" />
    </motion.a>;
}